import { useMemo } from "react";

import { Link, useLocation } from "react-router-dom";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

const routeNameMap: Record<string, string> = {
  stats: "Estadísticas",

  workspaces: "Workspaces",

  integrations: "Integraciones",

  users: "Usuarios",

  active: "Activos",

  activity: "Actividad",

  settings: "Configuración",

  newsletter: "Newsletter",

  installer: "Instalador",

  admins: "Administradores",

  overlays: "Overlays",
};

export function DynamicBreadcrumbs() {
  const location = useLocation();

  const breadcrumbs = useMemo(() => {
    const paths = location.pathname.split("/").filter(Boolean);

    return paths.map((path, index) => {
      const isLast = index === paths.length - 1;

      const url = `/${paths.slice(0, index + 1).join("/")}`;

      const name =
        routeNameMap[path] || path.charAt(0).toUpperCase() + path.slice(1);

      return { name, url, isLast };
    });
  }, [location.pathname]);

  if (breadcrumbs.length === 0) return null;

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {breadcrumbs.map((crumb) => (
          <div key={crumb.url} className="flex items-center">
            <BreadcrumbItem className="hidden md:block">
              {crumb.isLast ? (
                <BreadcrumbPage>{crumb.name}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <Link to={crumb.url}>{crumb.name}</Link>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
            {!crumb.isLast && (
              <BreadcrumbSeparator className="hidden md:block" />
            )}
          </div>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
